/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExtractionRestartResponse } from '../../models/extraction-restart-response';
import { KeyType } from '../../models/key-type';

export interface RestartDeliveryNoteExtraction$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function restartDeliveryNoteExtraction(http: HttpClient, rootUrl: string, params: RestartDeliveryNoteExtraction$Params, context?: HttpContext): Observable<StrictHttpResponse<ExtractionRestartResponse>> {
  const rb = new RequestBuilder(rootUrl, restartDeliveryNoteExtraction.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExtractionRestartResponse>;
    })
  );
}

restartDeliveryNoteExtraction.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/extraction/restart';
